<div class="custom-item">
    <skl-star class="custom-item__star" [value]="data.favourite" (click)="$event.stopPropagation(); switchFavouriteClientAsync(data)"></skl-star>
    <div class="custom-item__row">
        <div class="custom-item__column">
            <span class="custom-item--main">{{ data.name }}</span>
            <span class="custom-item--sub">{{ translateClientTinKind(data.tinKind) }}: {{ data.tin }}</span>
        </div>
        <div class="custom-item__column">
            <span class="custom-item--sub">{{ data.address }}</span>
            <span class="custom-item--sub">{{ data.zipCode }} {{ data.city }}</span>
        </div>
    </div>
</div>